import http from "../http-common";
/* eslint-disable */
class KabupatenService {
  kabupatenList(page, itemPerPage, keyword, propinsi_id) {
    return http.get(
      "/kabupaten/list?page=" +
        page +
        "&item_per_page=" +
        itemPerPage +
        "&keyword=" +
        keyword +
        "&propinsi_id=" +
        propinsi_id,
      {
        headers: {
          "Content-type": "application/json",
          Authorization:
            "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
        },
      }
    );
  }

  create(data, propinsi_id) {
    var bodyFormData = new FormData();
    bodyFormData.append("name", data.name);
    bodyFormData.append("propinsi_id", propinsi_id);

    return http.post("/kabupaten", bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  update(id, data) {
    var bodyFormData = new FormData();
    bodyFormData.append("id", id);
    bodyFormData.append("name", data.name);
    bodyFormData.append("propinsi_id", propinsi_id);

    return http.put(`/kabupaten/${id}`, bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  delete(id) {
    return http.delete(`/kabupaten/${id}`, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }
}

export default new KabupatenService();
